import Status from '../../enums/Status';
import * as pollers from '../api/pollers/pollers';
import {stopOrderProcessing} from './site-actions';

const sendOrder = orderInformation => (dispatch, getState) => {
  const selectedPaymentMethod = orderInformation.payment.method;
    
  if (['klarna', 'klarna_later', 'klarna_now', 'klarna_slice'].indexOf(selectedPaymentMethod) !== -1
      && getState().klarna.status !== Status.SUCCESS) {
    dispatch(stopOrderProcessing());
    return;
  }
  
  pollers.placeOrderViaApiPoller.execPost(
    JSON.stringify(orderInformation),
    undefined,
    undefined,
    'application/json; charset=utf-8',
  );
};

const resolvePayment = paymentInformation => () => {
  pollers.resolvePaymentViaApiPoller.execPost(
    JSON.stringify(paymentInformation),
    undefined,
    undefined,
    'application/json; charset=utf-8',
  );
};

const changePayment = paymentInformation => () => {
  pollers.paymentChangeWithApiPoller.execPost(
    JSON.stringify(paymentInformation),
    undefined,
    undefined,
    'application/json; charset=utf-8',
  );
};

export {sendOrder, resolvePayment, changePayment};
